import { useState, useEffect, useRef } from 'react';
import Header from '../components/Header';
import WelcomeBanner from '../components/WelcomeBanner';
import GamePromotion from '../components/GamePromotion';
import GameCategories from '../components/GameCategories';
import GameCategoriesPublic from '../components/GameCategoriesPublic';
import DefaultGameCategoriesForPlayers from '../components/DefaultGameCategoriesForPlayers';
import BottomNav from '../components/BottomNav';
import AppInstallPopup from '../components/Popup/AppInstallPopup';
import { useBottomNav } from '../context/BottomNavContext';
import { useAuth } from '../context/AuthContext';
import MusicPlayer from '../components/common/MusicPlayer';
import Footer from '../components/common/Footer';

export default function HomePage() {
  const [showPopup, setShowPopup] = useState(false);
  const { height, isIOS } = useBottomNav();
  const [bottomPadding, setBottomPadding] = useState(height);
  const { tokens, user } = useAuth();
  const headerRef = useRef(null);
  const bannerRef = useRef(null);
  const promoRef = useRef(null);
  const [categoriesHeight, setCategoriesHeight] = useState(0);

  useEffect(() => {
    const isAppInstalled =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone ||
      document.referrer.includes('android-app://');

    const handleBeforeInstallPrompt = () => {
      if (!isAppInstalled) {
        const hasPromptBeenDismissed =
          localStorage.getItem('pwaPromptDismissed');
        if (!hasPromptBeenDismissed) {
          setTimeout(() => setShowPopup(true), 2000);
        }
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
    };
  }, []);

  useEffect(() => {
    const padding = isIOS ? height + 170 : height + 100;
    setBottomPadding(padding);
  }, [height, isIOS]);

  useEffect(() => {
    function updateCategoriesHeight() {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const bannerHeight = bannerRef.current?.offsetHeight || 0;
      const promoHeight = promoRef.current?.offsetHeight || 0;
      const totalHeight = headerHeight + bannerHeight + promoHeight;
      // height from context already includes nav and safe area
      const availableHeight = window.innerHeight - totalHeight - bottomPadding;
      setCategoriesHeight(availableHeight); // No -50
    }

    updateCategoriesHeight();
    window.addEventListener('resize', updateCategoriesHeight);
    return () => window.removeEventListener('resize', updateCategoriesHeight);
  }, [bottomPadding]);

  const handlePopupClose = () => {
    setShowPopup(false);
    localStorage.setItem('pwaPromptDismissed', 'true');
  };

  const renderGameCategories = () => {
    if (tokens && tokens.access.token) {
      // if (user && user.roleId === 8) {
      //   return <DefaultGameCategoriesForPlayers />;
      // }
      return <GameCategories categoriesHeight={categoriesHeight} />;
    } else {
      return <GameCategoriesPublic categoriesHeight={categoriesHeight} />;
    }
  };

  return (
    <>
      <div
        className={`min-h-screen relative ${isIOS ? 'ios-safe-bottom' : ''}`}
        style={{
          background: 'linear-gradient(180deg, #1E429A 0%, #100E26 100%)',
        }}
      >
        <MusicPlayer src='music/winning-the-lottery_by_commercialclips_preview.aac' />
        <div
          className='absolute top-0 left-0 right-0 bottom-0 pt-8 max-xs:pt-5'
          style={{
            paddingBottom: `${bottomPadding}px`,
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <div ref={headerRef}>
            <Header />
          </div>
          <div ref={bannerRef}>
            <WelcomeBanner />
          </div>
          <div ref={promoRef}>
            <GamePromotion />
          </div>
          {renderGameCategories()}
        </div>
        <BottomNav />
      </div>
      <AppInstallPopup isOpen={showPopup} onClose={handlePopupClose} />
    </>
  );
}
